import { AppsGrid } from "../components/AppsGrid";
import { ContactCTA } from "../components/ContactCTA";
import { Reveal } from "../components/Shared";

export default function Applications() {
  return (
    <main data-testid="applications-page" className="pt-[70px]">
      <section className="mx-auto max-w-7xl px-5 sm:px-8 pt-16 lg:pt-24 pb-4">
        <Reveal>
          <div className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Nos activités</div>
          <h1 className="mt-4 font-display font-semibold tracking-tight text-navy text-4xl sm:text-5xl lg:text-6xl max-w-3xl text-balance">
            Cinq activités, un même engagement.
          </h1>
          <p className="mt-5 max-w-xl text-muted-foreground leading-relaxed">
            Découvrez les cinq piliers de TIRERA GROUP — mobilité, immobilier, construction,
            commerce et services numériques. Cliquez sur une activité pour explorer ses services et fonctionnalités.
          </p>
        </Reveal>
      </section>
      <AppsGrid showHeader={false} />
      <ContactCTA />
    </main>
  );
}
